const ONLIST = 'ONLIST';
const OFFLIST = 'OFFLIST';

export default {
  ONLIST,
  OFFLIST,
};
